import ClipPolygon from './ClipPolygon.vue';
export default ClipPolygon;
